import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";

export default function NotFound() {
  const { lang } = useLang();
  return (
    <div data-testid="notfound-page" className="relative min-h-screen grain overflow-hidden flex items-center justify-center text-center px-5" style={{ background: "#11110F" }}>
      <img src="/photos/photo_ukok.jpg" alt="Altai" className="absolute inset-0 w-full h-full object-cover opacity-40 ken-burns" />
      <div className="absolute inset-0" style={{ background: "rgba(17,17,15,0.6)" }} />
      <div className="relative">
        <img src="/brand/argali_emblem_ru.png" alt="Логотип АРГАЛИ" width="543" height="501" className="h-24 w-auto mx-auto mb-4 drop-shadow-[0_6px_24px_rgba(0,0,0,0.5)]" />
        <span className="font-serif text-3xl tracking-[0.22em] text-argali-ivory">АРГАЛИ</span>
        <h1 className="display display-lg text-argali-ivory mt-6">
          {lang === "ru" ? "Похоже, дорога" : "It seems the road"}<br />
          {lang === "ru" ? "ушла не туда." : "went the wrong way."}
        </h1>
        <Link to="/" className="btn-bronze mt-10 inline-flex">{lang === "ru" ? "Вернуться на маршрут" : "Back to the route"}</Link>
      </div>
    </div>
  );
}
